import React from 'react';
import './App.css';
import {auth,provider} from './firebase';

function Login() {
    const signin=()=>{
        auth.signInWithPopup(provider).catch((error)=>alert(error.message));
    };
    return (
        <div className="login">
            <div className="login-logo">
                <img src="https://droplr.com/wp-content/uploads/2020/06/discord-logo-1200x400.jpg" />
            </div>
            <button onClick={signin}>Sign In</button>
            
        </div>
    )
}

export default Login
